/* eslint-disable prettier/prettier */
import get from 'lodash/get';
import * as types from './constants';

export const LEASE_TYPES = {
  REGISTRATION: 'registration',
  RENEWAL: 'renewal',
  AMENDMENT: 'amendment',
  LEASE_TERMINATION_COURT_ORDER: 'terminationByCourtOrder',
};

const initialSubleasePermissions = {
  allowSubContract: false,
  subleaseOwnerApprovalRequired: false,
  clearSubleaseAgreement: false,
};

const initialState = {
  loading: false,
  error: null,
  contracts: null,
  [LEASE_TYPES.REGISTRATION]: {
    workflowId: 'LEASE_REGISTRATION',
    applicationType: 'LEASE_REGISTRATION',
    currentStep: 0,
    form: {
      contractClassificationType: null,
      tenantType: null,
      diplomatType: 'embassy',
      adwaBillType: 'LESSOR',
      allowTenantSublease: false,
      isPetAllowed: false,
      deposit: 0,
    },
    subleasePermissions: initialSubleasePermissions,
    allowSubContract: false,
    subleaseOwnerApprovalRequired: false,
    clearSubleaseAgreement: false,
    application: null,
    applicationNumber: null,
    applicationStatus: '',
    savedUnits: [],
  },
  [LEASE_TYPES.RENEWAL]: {
    workflowId: 'LEASE_REGISTRATION',
    applicationType: 'LEASE_RENEWAL',
    currentStep: 0,
    subleasePermissions: initialSubleasePermissions,
    form: {},
    application: null,
    applicationId: null,
    applicationNumber: null,
    applicationStatus: '',
  },
  [LEASE_TYPES.AMENDMENT]: {
    workflowId: 'LEASE_REGISTRATION',
    applicationType: 'LEASE_AMENDMENT',
    currentStep: 0,
    form: {},
    application: null,
    applicationId: null,
    applicationNumber: null,
    applicationStatus: '',
    subleasePermissions: initialSubleasePermissions,
  },
  [LEASE_TYPES.LEASE_TERMINATION_COURT_ORDER]: {
    workflowId: 'LEASE_TERMINATION_COURT_ORDER',
    applicationType: 'LEASE_TERMINATION_COURT_ORDER',
    currentStep: 0,
  },
  occupantsRelation: [],
  leaseTypes: {
    ...LEASE_TYPES,
  },
  contractAmountDetails: null,
  selectedProperties: [],
};

export default function leaseReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.CLEAR_STATE:
      return {
        ...initialState,
      };
    case types.LEASE_SERVICE_ACTION_START:
      return {
        ...state,
        loading: true,
      };
    case types.LEASE_SERVICE_ACTION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.GENERAL_LEASE_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', 'oops_something_went_wrong'),
      };
    case types.INITIATE_LEASE_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.INITIATE_LEASE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload?.key]: {
          ...state[action.payload?.key],
          workflow: get(action.payload, 'workflow.result'),
          application: get(action.payload, 'application.result'),
          applicationId: get(action.payload, 'application.result.id'),
          propertyDetail: get(action.payload, 'property.result', null),
          applicationNumber: get(action.payload, 'application.result.applicationNumber', null),
          applicationStatus: get(action.payload, 'application.result.applicationStatus', null),
          form: initialState[action.payload?.key].form,
          onwaniAddress: get(action.payload, 'onwaniAddress', []),
        },
        error: null,
      };

    case types.INITIATE_LEASE_MULTIPLE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload?.key]: {
          ...state[action.payload?.key],
          workflow: get(action.payload, 'workflow.result'),
          // application: get(action.payload, 'application.result'),
          applicationId: get(action.payload, 'applicationId'),
          // applicationNumber: get(action.payload, 'application.result.applicationDetails.applicationNumber', null),
          // applicationStatus: get(action.payload, 'application.result.applicationDetails.applicationStatus', null),
          form: initialState[action.payload?.key].form,
          // onwaniAddress: get(action.payload, 'onwaniAddress', []),
          // isVilla: get(action.payload, 'isVilla', false),
          isMultipleUnits: get(action.payload, 'isMultipleUnits', false),
        },
        error: null,
      };
    case types.INITIATE_LEASE_APPLICATION_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.INITIATE_RENEWAL_AMENDMENT_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.INITIATE_RENEWAL_AMENDMENT_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload?.key]: {
          ...state[action.payload?.key],
          workflow: get(action.payload, 'workflow.result'),
          applicationId: get(action.payload, 'applicationId'),
          application: get(action.payload, 'application.result'),
          form: get(action.payload, 'formData.form'),
          property: get(action.payload, 'property.result', null),
          applicationNumber: get(action.payload, 'application.result.applicationDetails.applicationNumber', null),
          applicationStatus: get(action.payload, 'application.result.applicationDetails.applicationStatus', null),
          // onwaniAddress: get(action.payload, 'onwaniAddress', []),
          isMultipleUnits: get(action.payload, 'isMultipleUnits', false),
        },
        error: null,
      };
    case types.FETCH_LEASE_WORKFLOW:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_LEASE_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload?.key]: {
          ...state[action.payload?.key],
          workflow: get(action.payload, 'workflow.result'),
        },
        error: null,
      };

    case types.FETCH_LEASE_APPLICATION_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_LEASE_SUCCESS_APPLICATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_LEASE_APPLICATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          application: get(action.payload, 'application.result'),
          subleasePermissions: {
            ...state.subleasePermissions,
            allowSubContract: get(action.payload, 'application.result.allowSubContract'),
            subleaseOwnerApprovalRequired: get(action.payload, 'application.result.subleaseOwnerApprovalRequired'),
            clearSubleaseAgreement: get(action.payload, 'application.result.clearSubleaseAgreement'),
          },
          form: {
            ...state[action.payload?.workflow].form,
            premisesAddress: get(action.payload, 'application.result.property.premisesAddress'),
            LEASE_OTHERS: get(action.payload, 'documents.result', []).filter(doc => doc.type === 'LEASE_OTHERS'),
            LEASE_DIPLOMAT: get(action.payload, 'documents.result', []).filter(doc => doc.type === 'LEASE_DIPLOMAT'),
            COMMERCIAL_ACTIVITY_PERMIT: get(action.payload, 'documents.result', []).filter(
              doc => doc.type === 'COMMERCIAL_ACTIVITY_PERMIT',
            ),
            TOWN_PLANNING_APPROVAL: get(action.payload, 'documents.result', []).filter(
              doc => doc.type === 'TOWN_PLANNING_APPROVAL',
            ),
            PUBLIC_BENEFIT_ASSOCIATION: get(action.payload, 'documents.result', []).filter(
              doc => doc.type === 'PUBLIC_BENEFIT_ASSOCIATION',
            ),
            EXCEPTIONAL_ADDING_OCCUPANT: get(action.payload, 'documents.result', []).filter(
              doc => doc.type === 'EXCEPTIONAL_ADDING_OCCUPANT',
            ),
          },
        },
        error: null,
      };
    case types.FETCH_PREMISE_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_PREMISE_DETAILS_SUCCESS:
      const premiseNumber = get(action.payload, 'premise.premiseID');
      const plotId = parseInt(get(action.payload, 'plotId', null), 10);
      const formPremises = state?.[action.payload?.workflow]?.form?.premiseNumber;
      let newArr = [];
      if (state?.[action.payload?.workflow]?.isMultipleUnits) {
        newArr = [...formPremises];
        const selectedUnit = formPremises?.findIndex(
          premise => premise?.premiseNumber === premiseNumber && premise?.plotId === plotId,
        );
        newArr[selectedUnit] = {
          ...formPremises[selectedUnit],
          premiseAddress: get(action.payload, 'premise.premiseAddress'),
          premiseNumber,
        };
      }
      return {
        ...state,
        loading: false,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          form: {
            ...state?.[action.payload?.workflow].form,
            premiseNumber: state?.[action.payload?.workflow]?.isMultipleUnits ? newArr : premiseNumber,
            premisesAddress: get(action.payload, 'premise.premiseAddress'),
          },
        },
        error: null,
      };
    case types.FETCH_ALL_PREMISE_DETAILS_SUCCESS:
      const premisesResponse = get(action.payload, 'premisesRes', []);
      const premiseIDs = state?.[action.payload?.workflow]?.form?.premiseNumber
        ?.filter(prem => prem?.premiseNumber && !prem?.premiseAddress)
        ?.map(pr => pr?.premiseNumber);
      const oldPremises = (state?.[action.payload?.workflow]?.form?.premiseNumber || [])?.filter(prem =>
        premiseIDs.includes(prem?.premiseNumber),
      );
      const updatedPremises = [];
      premisesResponse.forEach(newEl => {
        oldPremises.forEach(oldEl => {
          if (+oldEl.premiseNumber === +newEl?.premiseID) {
            /* eslint-disable */
            oldEl.premiseAddress = newEl?.premiseAddress;
            // if (!updatedPremises.includes(oldEl)) {
            //   updatedPremises.push(oldEl);
            // }
          }
        });
      });
      // oldPremises.forEach((oldEl) => {
      //   if (!oldEl.premiseAddress) {
      //     /* eslint-disable */
      //     oldEl.failed = true;
      //     updatedPremises.push(oldEl);
      //   }
      // });

      return {
        ...state,
        loading: false,
        [action.payload?.workflow]: {
          ...state?.[action.payload?.workflow],
          form: {
            ...state?.[action.payload?.workflow].form,
            premiseNumber: [
              ...updatedPremises?.flat(),
              ...(state?.[action.payload?.workflow]?.form?.premiseNumber || [])?.filter(
                prem => !premiseIDs.includes(prem?.premiseID),
              ),
            ],
          },
        },
        error: null,
      };
    case types.FETCH_PREMISE_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        [action.payload?.workflow]: {
          ...state?.[action.payload?.workflow],
        },
        error: get(action.payload, 'error', 'oops_something_went_wrong'),
      };
    // case types.FETCH_RENEWAL_PREMISE_DETAILS_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     renewal: {
    //       ...state.renewal,
    //       form: {
    //         ...state.renewal.form,
    //         premiseNumber: get(action.payload, 'premise.result.premiseDetailResponse.premiseID'),
    //         premisesAddress: get(action.payload, 'premise.result.premiseDetailResponse.premiseAddress'),
    //       },
    //     },
    //     error: null,
    //   };
    // case types.FETCH_RENEWAL_PREMISE_DETAILS_ERROR:
    //   return {
    //     ...state,
    //     loading: false,
    //     renewal: {
    //       ...state.renewal,
    //       form: {
    //         ...state.renewal.form,
    //         premiseNumber: '',
    //         premisesAddress: '',
    //       },
    //     },
    //     error: get(action.payload, 'error', 'oops_something_went_wrong'),
    //   };
    // case types.FETCH_AMENDMENT_PREMISE_DETAILS_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     amendment: {
    //       ...state.amendment,
    //       form: {
    //         ...state.amendment.form,
    //         premiseNumber: get(action.payload, 'premise.result.premiseDetailResponse.premiseID'),
    //         premisesAddress: get(action.payload, 'premise.result.premiseDetailResponse.premiseAddress'),
    //       },
    //     },
    //     error: null,
    //   };

    // case types.FETCH_AMENDMENT_PREMISE_DETAILS_ERROR:
    //   return {
    //     ...state,
    //     loading: false,
    //     renewal: {
    //       ...state.amendment,
    //       form: {
    //         ...state.amendment.form,
    //         premiseNumber: '',
    //         premisesAddress: '',
    //       },
    //     },
    //     error: get(action.payload, 'error', 'oops_something_went_wrong'),
    //   };
    case types.FETCH_PERSON_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_PERSON_DETAILS_SUCCESS:
      const fetchPersonLeaseType = get(action.payload, 'leaseType', LEASE_TYPES.REGISTRATION);
      return {
        ...state,
        loading: false,
        [fetchPersonLeaseType]: {
          ...state[fetchPersonLeaseType],
          form: {
            ...state[fetchPersonLeaseType].form,
            ...get(action.payload, 'tenantObject', {}),
          },
        },
      };
    case types.FETCH_LEASE_COMPANY_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_LEASE_COMPANY_DETAILS_SUCCESS:
      const fetchCompanyLeaseType = get(action.payload, 'leaseType', LEASE_TYPES.REGISTRATION);
      return {
        ...state,
        loading: false,
        [fetchCompanyLeaseType]: {
          ...state[fetchCompanyLeaseType],
          form: {
            ...state[fetchCompanyLeaseType].form,
            companyName: get(action.payload, 'company.result.companyNameEn', null),
            companyNameAr: get(action.payload, 'company.result.companyNameAr', null),
            compPhone: get(action.payload, 'company.result.mobileNumber', null),
            compEmail: get(action.payload, 'company.result.companyEmail', null),
            businessFlags: get(action.payload, 'company.result.businessFlags', null),
          },
        },
      };
    case types.FETCH_LEASE_RESERVE_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_LEASE_RESERVE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload?.workflow]: {
          ...state?.[action.payload?.workflow],
          form: {
            ...state?.[action.payload?.workflow]?.form,
            reserveName: get(action.payload, 'reserve.result.businessResponse.businessName.businessNameEN', null),
          },
        },
      };
    case types.CHANGE_LEASE_PROPERTY:
      return {
        ...state,
        registration: {
          ...state.registration,
          applicationId: null,
        },
      };
    case types.UPDATE_MULTIPLE_OCCUPANTS:
      return {
        ...state,
        loading: false,
        [action.payload?.workflow]: {
          ...state?.[action.payload?.workflow],
          form: {
            ...state?.[action.payload?.workflow].form,
            occupants: get(action.payload, 'occupants', []),
          },
        },
      };
    case types.CHANGE_LEASE_FORM:
      return {
        ...state,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          form: {
            ...state[action.payload?.workflow]?.form,
            ...get(action.payload, 'data', state[action.payload?.workflow]?.form),
          },
        },
      };
    case types.CHANGE_LEASE_WORKFLOW_STEP:
      return {
        ...state,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          currentStep: action.payload?.step,
        },
      };
    case types.ADD_TO_LEASE_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case types.ADD_TO_LEASE_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'message'),
      };
    case types.ADD_OCCUPANT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_MULTIPLE_OCCUPANT:
      return {
        ...state,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          form: {
            ...state[action.payload?.workflow].form,
            multipleOccupants: [
              ...(state[action.payload?.workflow].form.multipleOccupants || []),
              action.payload?.data,
            ],
          },
        },
        loading: false,
        error: null,
      };
    case types.ADD_OCCUPANT_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          form: {
            ...state[action.payload?.workflow].form,
            occupants: [...(state[action.payload?.workflow].form.occupants || []), action.payload?.data],
          },
        },
      };
    case types.UPDATE_OCCUPANT_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          form: {
            ...state[action.payload?.workflow].form,
            occupants: action.payload?.data,
          },
        },
      };
    case types.REMOVE_OCCUPANT:
      return {
        ...state,
        loading: true,
      };
    case types.REMOVE_OCCUPANT_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          form: {
            ...state[action.payload?.workflow].form,
            occupants: action.payload.newOccupants,
          },
        },
      };
    case types.UPLOAD_LEASE_DOCUMENT:
      return {
        ...state,
        loading: true,
      };
    case types.UPLOAD_LEASE_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          form: {
            ...state[action.payload?.workflow].form,
            [action.payload?.type]: [
              ...(state[action.payload?.workflow].form[action.payload?.type] || []),
              get(action.payload, 'document.result'),
            ],
          },
        },
      };
    case types.DELETE_LEASE_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_LEASE_DOCUMENT_SUCCESS: {
      const newDocs = (state[action.payload?.workflow].form[action.payload?.type] || []).filter(
        file => file.id !== action.payload?.fileId,
      );
      return {
        ...state,
        loading: false,
        error: null,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          form: {
            ...state[action.payload?.workflow].form,
            [action.payload?.type]: newDocs,
          },
        },
      };
    }
    case types.DOWNLOAD_LEASE_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_LEASE_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.SUBMIT_LEASE_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SUBMIT_LEASE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          currentStep: state[action.payload?.workflow].currentStep + 1,
        },
      };
    case types.CHECKOUT_LEASE_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.CHECKOUT_LEASE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        [action.payload?.workflow]: initialState[action.payload?.workflow],
      };
    case types.SET_LEASE_REGISTRATION_FORM:
      return {
        ...state,
        registration: {
          ...state.registration,
          application: get(action.payload, 'application', {}),
          applicationId: get(action.payload, 'applicationId'),
          subleasePermissions: get(action.payload, 'subleasePermissions'),
          form: get(action.payload, 'form'),
          propertyDetail: get(action.payload, 'property.result', null),
          applicationStatus: get(action.payload, 'applicationStatus'),
          onwaniAddress: get(action.payload, 'onwaniAddress', []),
          applicationNumber: get(action.payload, 'applicationNumber', []),
          isMultipleUnits: get(action.payload, 'isMultipleUnits', false),
          isVilla: get(action.payload, 'isVilla', false),
          occupants: get(action.payload, 'application.result.occupants', []),
        },
      };
    case types.SET_LEASE_RENEWAL_FORM:
      return {
        ...state,
        renewal: {
          ...state.renewal,
          application: get(action.payload, 'application', {}),
          applicationId: get(action.payload, 'applicationId'),
          form: get(action.payload, 'form'),
          propertyDetail: get(action.payload, 'property.result', null),
          applicationStatus: get(action.payload, 'applicationStatus'),
          onwaniAddress: get(action.payload, 'onwaniAddress', []),
          subleasePermissions: get(action.payload, 'subleasePermissions'),
          applicationNumber: get(action.payload, 'applicationNumber', []),
          isMultipleUnits: get(action.payload, 'isMultipleUnits', false),
          isVilla: get(action.payload, 'isVilla', false),
        },
      };
    case types.SET_LEASE_AMENDMENT_FORM:
      return {
        ...state,
        amendment: {
          ...state.amendment,
          application: get(action.payload, 'application', {}),
          applicationId: get(action.payload, 'applicationId'),
          form: get(action.payload, 'form'),
          propertyDetail: get(action.payload, 'property.result', null),
          applicationStatus: get(action.payload, 'applicationStatus'),
          subleasePermissions: get(action.payload, 'subleasePermissions'),
          onwaniAddress: get(action.payload, 'onwaniAddress', []),
          applicationNumber: get(action.payload, 'applicationNumber', []),
          isMultipleUnits: get(action.payload, 'isMultipleUnits', false),
          isVilla: get(action.payload, 'isVilla', false),
        },
      };
    case types.SET_LEASE_FORM_ERROR:
      return {
        loading: false,
        error: action?.payload || null,
      };
    case types.FETCH_LEASE_CONTRACTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_LEASE_CONTRACTS_SUCCESS:
      return {
        ...state,
        loading: false,
        contracts: {
          amendmentFee: { ...get(action.payload, 'amendmentFee.result', {}) },
          ...get(action.payload, 'contracts.result', {}),
        },
      };
    case types.FETCH_AMENDMENT_FEE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_AMENDMENT_FEE_SUCCESS:
      return {
        ...state,
        loading: false,
        contracts: {
          ...(state.contracts || {}),
          amendmentFee: get(action.payload, 'amendmentFee.result'),
        },
      };
    case types.RESET_LEASE_APPLICATION:
      return {
        ...state,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          currentStep: 0,
          applicationId: null,
        },
        error: null,
      };
    case types.DISCARD_LEASE_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
        openDialogueCancel: false,
      };
    case types.DISCARD_LEASE_APPLICATION_SUCCESS:
      return {
        ...state,
        [action.payload?.workflow]: {
          ...initialState[action.payload?.workflow],
        },
        error: null,
      };
    case types.FETCH_LEASE_OCCUPANT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_LEASE_OCCUPANT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        occupant: action.occupant,
      };
    case types.UPLOAD_LEASE_CLOSURE_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_LEASE_CLOSURE_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.ADD_LEASE_PRIMARY_LESSOR:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_LEASE_PRIMARY_LESSOR_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_OCCUPANT_RELATIONS:
      return {
        ...state,
        error: false,
        occupantsRelation: action?.payload,
      };
    case types.ADD_LEASE_PROPERTIES:
      return {
        ...state,
        loading: true,
      };
    case types.ADD_LEASE_PROPERTIES_SUCCESS:
    case types.ADD_LEASE_PROPERTIES_VALIDATION_ERROR:
      return {
        ...state,
        loading: false,
      };
    case types.ADD_LEASE_PROPERTIES_ERROR:
      return {
        ...state,
        loading: false,
        error: action?.payload || null,
      };

    case types.FETCH_LEASABLE_PROPERTIES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_LEASABLE_PROPERTIES_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.FETCH_LEASABLE_PROPERTIES_ERROR:
      return {
        ...state,
        loading: false,
      };
    case types.FETCH_COMPANY_TRADE_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.REMOVE_UNIT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.REMOVE_LAST_UNIT:
      return {
        ...state,
        loading: false,
        openDialogueCancel: true,
      };
    case types.REMOVE_UNIT_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedProperties: get(action.payload, 'newPropertyUnits', []),
        // [action.payload?.workflow]: {
        //   ...state[action.payload?.workflow],
        // },
      };
    case types.TOGGLE_DIALOGUE_CANCEL:
      return {
        ...state,
        openDialogueCancel: get(action.payload, 'dialogueStatus', false),
      };
    case types.FETCH_SELECTED_PROPERTIES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_SELECTED_PROPERTIES_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedProperties: get(action.payload, 'selectedProperties', []),
      };
    case types.LEASE_FETCH_CONTRACT_AMOUNT:
      return {
        ...state,
        loading: false,
        contractAmountDetails: action?.payload,
      };
    case types.LEASE_RESET_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.SET_ALLOW_SUB_CONTRACT:
      return {
        ...state,
        allowSubContract: action?.payload,
      };

    case types.SET_IS_OWNER_APPROVAL_REQUIRED:
      return {
        ...state,
        subleaseOwnerApprovalRequired: action?.payload,
      };

    case types.SET_ALLOW_CLEAR_SUBLEASE_AGREEMENT:
      return {
        ...state,
        clearSubleaseAgreement: action?.payload,
      };

    case types.SET_SUB_LEASE_PERMISSIONS: {
      return {
        ...state,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          subleasePermissions: action?.payload?.permissions,
        },
      };
    }

    case types.FETCH_REPRESENTATIVE_DETAILS_LOADING: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }

    case types.FETCH_REPRESENTATIVE_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        [action.payload?.workflow]: {
          ...state[action.payload?.workflow],
          form: {
            ...state[action.payload?.workflow]?.form,
            ...get(action.payload, 'data', state[action.payload?.workflow]?.form),
          },
        },
      };
    }

    case types.FETCH_REPRESENTATIVE_DETAILS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    default:
      return state;
  }
}
